if (!customElements.get('product-modal')) {
	customElements.define('product-modal', class ProductModal extends ModalDialog {
		constructor() {
			super();

			this.closeEvent = new CustomEvent('product:modal-close');
			this.openEvent = new CustomEvent('product:modal-open');
		}

		hide() {
			super.hide();
			document.dispatchEvent(this.closeEvent);
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
			document.dispatchEvent(this.openEvent);
		}

		showActiveMedia() {
			const mediaId = this.openedBy?.getAttribute('data-media-id');
			const container = this.querySelector('[role="document"]');

			if (!mediaId || !container) {
				return;
			}

			const activeMedia = this.buildActiveMedia(mediaId);

			if (!activeMedia) {
				return;
			}

			container.replaceChildren(activeMedia);
			activeMedia.classList.add('is-active');
			activeMedia.scrollIntoView();
			container.scrollLeft = Math.max(0, ((activeMedia.width || activeMedia.clientWidth || 0) - container.clientWidth) / 2);

			const activeMediaTemplate = activeMedia.querySelector?.('template');
			const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
				activeMedia.loadContent();
			}
		}

		buildActiveMedia(mediaId) {
			const source = this.getSourceMedia(mediaId);
			const sourceImage = source?.querySelector('img.no-js-hidden') || source?.querySelector('img');

			if (sourceImage) {
				return this.buildModalImage(sourceImage, mediaId);
			}

			const sourceDeferredMedia = source?.querySelector('deferred-media, product-model');

			if (!sourceDeferredMedia) {
				return null;
			}

			const clone = sourceDeferredMedia.cloneNode(true);
			clone.setAttribute('data-media-id', mediaId);
			clone.classList.remove('no-js-hidden');
			clone.querySelectorAll('[id]').forEach((element) => {
				element.id = `${element.id}-lazy-modal`;
			});
			return clone;
		}

		getSourceMedia(mediaId) {
			const sectionId = this.id.replace('ProductModal-', '');
			const escapedMediaId = window.CSS?.escape ? CSS.escape(mediaId) : mediaId;
			const gallery = document.getElementById(`MediaGallery-${sectionId}`);
			return gallery?.querySelector(`.product-media-main[data-media-id="${escapedMediaId}"]`);
		}

		buildModalImage(sourceImage, mediaId) {
			const image = sourceImage.cloneNode(false);
			const widths = [550, 900, 1445, 1800];
			const modalWidth = 1100;
			const sourceWidth = Number(sourceImage.getAttribute('width')) || sourceImage.naturalWidth || modalWidth;
			const sourceHeight = Number(sourceImage.getAttribute('height')) || sourceImage.naturalHeight || modalWidth;
			const modalHeight = Math.ceil(modalWidth * (sourceHeight / sourceWidth));
			const baseUrl = sourceImage.currentSrc || sourceImage.src;

			image.classList.remove('no-js-hidden');
			image.loading = 'eager';
			image.decoding = 'async';
			image.setAttribute('data-media-id', mediaId);
			image.setAttribute('width', String(modalWidth));
			image.setAttribute('height', String(modalHeight));
			image.setAttribute('sizes', '(min-width: 990px) calc(100vw - 22rem), (min-width: 750px) calc(100vw - 8rem), calc(100vw - 2rem)');
			image.srcset = widths.map((width) => `${this.imageUrlForWidth(baseUrl, width)} ${width}w`).join(', ');
			image.src = this.imageUrlForWidth(baseUrl, 1800);
			return image;
		}

		imageUrlForWidth(value, width) {
			try {
				const url = new URL(value, window.location.href);
				url.searchParams.set('width', String(width));
				return url.href;
			} catch (error) {
				return value;
			}
		}
	});
}
